import api from "./api";

const b64 = (s) => { const p = "=".repeat((4 - (s.length % 4)) % 4); const r = atob((s + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...r].map((c) => c.charCodeAt(0))); };

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

async function reg() { return navigator.serviceWorker.register("/sw.js"); }

export async function pushStatus() {
  if (!pushSupported()) return isIOS() && !isStandalone() ? "needs-install" : "unsupported";
  if (Notification.permission === "denied") return "denied";
  const r = await navigator.serviceWorker.getRegistration("/");
  const s = r && (await r.pushManager.getSubscription());
  return s && Notification.permission === "granted" ? "on" : "off";
}

// Must be called from a user gesture (button tap).
export async function enablePush() {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return perm === "denied" ? "denied" : "off";
  const r = await reg();
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/firm/native-phone/push/key");
  let s = await r.pushManager.getSubscription();
  if (!s) s = await r.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64(data.public_key) });
  await api.post("/firm/native-phone/push/subscribe", s.toJSON());
  return "on";
}

export async function disablePush() {
  const r = await navigator.serviceWorker.getRegistration("/");
  const s = r && (await r.pushManager.getSubscription());
  if (s) { await api.post("/firm/native-phone/push/unsubscribe", { endpoint: s.endpoint }).catch(() => {}); await s.unsubscribe().catch(() => {}); }
  return "off";
}

// Re-sync an existing subscription (handles key rotation / device changes) without prompting.
export async function syncPush() {
  if (!pushSupported() || Notification.permission !== "granted") return;
  const r = await navigator.serviceWorker.getRegistration("/");
  const s = r && (await r.pushManager.getSubscription());
  if (s) await api.post("/firm/native-phone/push/subscribe", s.toJSON()).catch(() => {});
}

export async function pushLogout() {
  if (!pushSupported()) return;
  await Promise.race([disablePush().catch(() => {}), new Promise((ok) => setTimeout(ok, 1200))]);
}
